import { inject, InjectionToken } from '@angular/core';

import { CapabilitiesService } from '../shared-context/capabilities.service';

export const enum AadAppId {
    Pwa = '0ec893e0-5785-4de6-99da-4ed124e5296c',
    OfficeHome = '4345a7b9-9a63-4910-a426-35363201d503'
}

export const AAD_APP_ID = new InjectionToken<AadAppId>('AAD_APP_ID', {
    providedIn: 'root',
    factory: () => {
        const capabilitiesService = inject(CapabilitiesService);
        return capabilitiesService.capabilities.pwaEnabled ? AadAppId.Pwa : AadAppId.OfficeHome;
    }
});
